import {useTranslation} from 'react-i18next';
import ATTENDANCE_CHECK from '../../../../public/static/v4/event/icon-attendance-check.svg';
import PageImage from '../../../common/component/PageImage';
import SingleText from '../../../common/component/SingleText';
import {formatNumber} from '../../../common/util/number';
import {IAttendanceItemV4} from '../../type';
import EventButtonV4 from '../EventButtonV4';
import EventRowItemV4 from '../EventRowItemV4';

interface IProps {
  item: IAttendanceItemV4;
  onClick?: (item: IAttendanceItemV4) => void;
}

export default function AttendanceItemV4({item, onClick}: IProps) {
  const {t} = useTranslation();
  const {
    type,
    attendanceCount,
    isCurrent,
    isCompleted,
    currentRound,
    round,
    reward,
  } = item;

  const isClickType = type === 'click';
  const isCashReward = reward?.type === 'cash';
  const isLuckyDrawReward = reward?.type === 'luckyDraw';
  const isTicketReward = reward?.type === 'ticket';

  const isPast = currentRound > round;
  const isFinish = isCompleted || isPast;

  const finishOpacityCn = cn(isFinish && 'opacity-30');
  const rewardImage = reward?.image;

  const isRightElementBtnType = isClickType && round <= currentRound;
  const showRewardImage = !!rewardImage && !isRightElementBtnType;
  const showAttendanceBtn = !showRewardImage && isRightElementBtnType;

  return (
    <EventRowItemV4
      isRound
      className={cn('gap-x-22', {
        '!bg-white/5 pointer-events-none': isFinish,
        'bg-white': isCurrent,
        'bg-white/20': currentRound < round,
        '!pr-0': showRewardImage,
      })}
      leftElement={
        <>
          <SingleText
            className={cn('leading-19 tracking-[-0.4px]', finishOpacityCn, {
              's15-bold-black': isCurrent,
              's15-bold-white': !isCurrent,
              '!text-white': isFinish,
            })}
            data-testid="attendance-count-text"
          >
            {t(
              isClickType
                ? 'crm_attendance_status_day'
                : 'crm_attendance_status_day_short',
              {
                value: formatNumber(attendanceCount),
              }
            )}
          </SingleText>
          {reward && (
            <SingleText
              className={cn('leading-19 tracking-[-0.4px]', finishOpacityCn, {
                's13-regular-black': isCurrent,
                's13-regular-white': !isCurrent,
                '!text-white': isFinish,
              })}
              data-testid="quantity-text"
            >
              {isCashReward &&
                t('crm_attendance_reward_cash', {
                  value: formatNumber(reward.quantity),
                })}
              {isLuckyDrawReward && t('crm_attendance_reward_slot_ticket')}
              {isTicketReward && t('crm_attendance_reward_gift_ticket')}
            </SingleText>
          )}
        </>
      }
      rightElementClassName="flex-shrink-0"
      rightElement={
        <>
          {showAttendanceBtn && (
            // TODO: V4 로딩 처리
            <EventButtonV4
              isWhiteBg={false}
              disabled={isFinish}
              className={isFinish ? '!bg-light-grey-10' : undefined}
              text={t(
                isCompleted
                  ? 'crm_attendance_button_complete'
                  : 'crm_attendance_button_before'
              )}
              onClick={() => {
                isCurrent && isClickType && onClick?.(item);
              }}
            />
          )}
          {showRewardImage && (
            <div className="relative">
              <PageImage
                src={rewardImage}
                isLazy={false}
                alt={isCompleted ? 'completed' : 'reward'}
                className={cn('h-80', {
                  'opacity-15': isFinish,
                })}
              />
              {isCompleted && (
                <img
                  className="h-35 absolute top-22 right-39"
                  alt=""
                  src={ATTENDANCE_CHECK}
                />
              )}
            </div>
          )}
        </>
      }
      data-testid="attendance-item"
    />
  );
}
